import type { FieldCodec } from 'v5/core/entity-values/values.types';
import { validateField, validation } from './validation';

function isEmpty(value: number | null): boolean {
  return value === null;
}

/** Reference to another entity by id, kept in a core column (`organisation_id` / `represented_by_id`). */
export const entityRefCodec: FieldCodec<'entity-ref'> = {
  decode(entity, spec) {
    return entity[spec.column] ?? null;
  },
  encode(value, spec) {
    return {
      type: 'core-changes',
      changes: [{ column: spec.column, value }]
    };
  },
  empty() {
    return null;
  },
  isEmpty,
  validate(value, spec) {
    return validateField(value, spec, isEmpty, () => validation.valid());
  }
};
